module.exports = __webpack_public_path__ + "src/assets/img/share/level2/18ae62cf8fc52f597b373d8ceb074316.png";